import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";
import { filtersToQueryParams } from "utils/misc";

export default function useSearch(filters = {}) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchSearchResults() {
      setLoading(true);
      const { response, data } = await API.fetchSearchResults(
        token,
        filtersToQueryParams(filters)
      );

      if (response.ok) {
        setResult(data);
        setLoading(false);
        setError(null);
      } else {
        setError({ status: response.status, ...data });
        setLoading(false);
      }
    }

    if (filters?.query && filters?.type) {
      fetchSearchResults();
    }
  }, [token, Object.values(filters).join("__")]);

  return {
    loading,
    error,
    type: result?.type,
    results: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
